/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React from 'react'
import InteractionRegistry from './InteractionRegistry.js'
import _ from 'lodash'
import SplashPage from "../../components/partials/SplashPage/SplashPage";
import ChapterOpener, { chapterOpener} from "../../components/partials/ChapterOpener/ChapterOpener"
import { OverlayProvider } from '../../components/partials/Overlay/Overlay.jsx';
import { CMHOC } from "../../components/partials/CMProvider/CMProvider"
const Sequencer = props => {
    //takes in currentLocation pointers and moduleData
    //decides what to render based on that
    //also handles completion events - decide what happens when you complete a segment or indexes change
    const currentModule = props.moduleData
    const currentLocation = props.currentLocation
    const currentLesson = currentModule.lessons[currentLocation.lesson]
    const currentChapter = currentLesson.chapters[currentLocation.chapter]
    const currentSegment = currentChapter.segments[currentLocation.segment]


    const currentBreadCrumb = props.currentBreadCrumb
   
    const isLastModule = currentLocation.module + 1 >= props.contentData.modules.length;
    const isLastLesson = currentLocation.lesson + 1 >= currentModule.lessons.length
    const isLastChapter = currentLocation.chapter + 1 >= currentLesson.chapters.length
    const isLastSegment = currentLocation.segment + 1 >= currentChapter.segments.length

    const isFirstLesson = currentLocation.lesson <= 0
    const isFirstChapter = currentLocation.chapter <= 0
    const isFirstSegment = currentLocation.segment <= 0

    const navigateTo = props.setCurrentLocation

    const [hideSplash, setHideSplash] = React.useState(props.isLocalHost || false)
    const [currentSubSegment, setCurrentSubSegment] = React.useState(0);
    // create a ref for the previous location
    const previousCurrentLocationRef = React.useRef();
    // reset the current sub segment if location is changed.
    if ((currentLocation !== previousCurrentLocationRef.current)){
        setCurrentSubSegment(0);   
        previousCurrentLocationRef.current = currentLocation;    
    }

    const handleModuleCompletion = () => {    
        //sco finished
        if(!isLastModule){
            props.setLocationValues({
                module: currentLocation.module + 1,
                lesson: 0,
                chapter: 0,
                segment: 0,
            })
        }else{
            console.log("that was the last module and the course should mark complete" );
        }
    }

    const handleLessonCompletion = () => {
        if(!isLastLesson){
            props.setLocationValues({
                lesson: currentLocation.lesson + 1,
                chapter: 0,
                segment: 0,
            })
         }else{
           handleModuleCompletion()
         }
    }

    const handleChapterCompletion = () => {
        if(!isLastChapter){

            props.setLocationValues({
                chapter: currentLocation.chapter + 1,
                segment: 0
            })
         }else{
             //fin
             handleLessonCompletion()
         }
    }
    const handleSegmentCompletion = () => {
        props.markSegmentComplete(currentLocation);
        if(!isLastSegment){
            props.setLocationValue(
                'segment',
                currentLocation.segment + 1
            )
        }else{
            //fin
            handleChapterCompletion()
        }
    }

    const handleSubSegmentCompletion = () => {

        // increment current Subset or leave segment (next)
        if (currentSubSegment === subSegments.length - 1){
            handleSegmentCompletion();
        }else{
            setCurrentSubSegment(currentSubSegment + 1)
        }

    }
    const handleGoToPreviousSubSection = () => {

        // setCurrentSubSegment(currentSubSegment - 1)
        if (currentSubSegment <= 0){
            handleGoToPreviousSegment();
        }else{
            setCurrentSubSegment(currentSubSegment - 1)
        }


        // decriment current Subset or leave segment (prev)

    }
    const handleGoToPreviousLesson = () => {
        if(!isFirstLesson) {
            props.setLocationValues({
                lesson: currentLocation.lesson - 1,
                chapter: 0,
                segment: 0,
            })
        } else {
          // cant go back any more, this is the first segment of the first chapter of the first lesson
        }
    }

    const handleGoToPreviousChapter = () => {
        if(!isFirstChapter) {
            props.setLocationValues({
                chapter: currentLocation.chapter - 1,
                segment: 0
            })
        } else {
            //fin
            handleGoToPreviousLesson()
        }
    }

    const handleGoToPreviousSegment = () => {
        if(!isFirstSegment){
            props.setLocationValue(
                'segment',
                currentLocation.segment - 1
            )
        } else {
            //fin
            handleGoToPreviousChapter()
        }
    }

    const goToNext = () => {
        if(!isLastSegment){
            handleSegmentCompletion()
         }else{
            if(!isLastLesson)
                handleLessonCompletion()
            else
                handleChapterCompletion()
         }
    }

    var interaction = InteractionRegistry(currentSegment.type, {
        data: currentSegment,
        breadcrumbs: currentBreadCrumb,
        navigateTo: navigateTo,
        goToNext: goToNext,
        onComplete: handleSubSegmentCompletion,
        markComplete: () => props.markSegmentComplete(currentLocation),
        goBackToPreviousSegment: handleGoToPreviousSubSection,
        type: currentSegment.type,
        globals: props.globals,
        key: `${JSON.stringify(currentLocation)} ${props.resetIndex}`,
        resetSco: props.resetSco,
        setEditorShortcut: props.setEditorShortcut,
        progress: props.progress
    });

    const getSubSegmenets = () => {
        var tempSubSegments = [];

        if (currentSegment
            && currentSegment.ChapterOpener !== undefined
            && currentSegment.ChapterOpener.display === true) {
            tempSubSegments.push(<ChapterOpener
                data={currentSegment.ChapterOpener}
                breadcrumbs={currentBreadCrumb}
                goBackToPreviousSegment={handleGoToPreviousSubSection}
                onComplete={() => { handleSubSegmentCompletion() }}
                globals={props.globals}
                resetSco={props.resetSco}
                markComplete={() => props.markSegmentComplete(currentLocation)}
                setQuit = {props.setQuit}
            />)
        }

        tempSubSegments.push(interaction);

        if (currentSegment
            && currentSegment.ChapterCloser !== undefined
            && currentSegment.ChapterCloser.display === true) {
            tempSubSegments.push(
                <ChapterOpener
                    data={currentSegment.ChapterCloser}
                    breadcrumbs={currentBreadCrumb}
                    goBackToPreviousSegment={handleGoToPreviousSubSection}
                    onComplete={() => {
                        handleSubSegmentCompletion();
                    }}
                    globals={props.globals}
                    resetSco={props.resetSco}
                    setQuit = {props.setQuit}
                />
            )
        }
        return tempSubSegments;
    }
    const subSegments = getSubSegmenets();

    var Interaction = subSegments[currentSubSegment];
    
    if(currentSegment && currentSegment.type){
        return (
            <div className="Sequencer">
                <OverlayProvider>
                    {
                        CMHOC(props,
                            <>
                                {
                                    (props.globals?.showSplashScreen?.toLowerCase() === 'true' && !hideSplash) ? <SplashPage
                                        data={props?.globals?.splashData}
                                        onComplete={() => {
                                            props.setLocationValues({
                                                module: 0,
                                                lesson: 0,
                                                chapter: 0,
                                                segment: 0,
                                            })
                                            setHideSplash(true)
                                        }}

                                    /> : Interaction
                                }
                            </>
                        )
                    }
                </OverlayProvider>
            </div>
        )
    }
    return <div className={`Loading`}>Loading...</div>
}

export default Sequencer
